import { useQuery } from '@tanstack/react-query'
import { createFileRoute } from '@tanstack/react-router'
import { photoSearchSchema } from '@/features/photo/model/search'
import { PhotoPage } from '@/features/photo/pages/photo-page'
import { workspaceQueryOptions } from '@/lib/workspace'

export const Route = createFileRoute('/_auth/w/$workspaceSlug/photo')({
  validateSearch: photoSearchSchema,
  component: Screen,
})
function Screen() {
  const { workspaceSlug } = Route.useParams()
  const workspace = useQuery(workspaceQueryOptions(workspaceSlug))
  return (
    <PhotoPage
      slug={workspaceSlug}
      canWrite={workspace.data?.role === 'owner' || workspace.data?.role === 'editor'}
      weddingDate={workspace.data?.wedding?.weddingDate ?? null}
    />
  )
}
